<div class="image-gallery">
  <div class="image-wrapper" *ngFor="let image of images; let index = index">
    <a (click)="viewImage(index)">
      <img [src]="image.small_url" class="mat-elevation-z2 image" />
    </a>
  </div>
</div>
